import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { listOption } from './AutoCompleteField'
import { useSearchUsersLiteLazyQuery } from '../../__generated__/graphql'
import AsyncAutoCompleteField from './AsyncAutoCompleteField'
import { isNil, uniqBy } from 'lodash-es'

const AsyncAutoCompleteUsers: React.FC = () => {
  const t = useAppTranslations()
  const [queryName, setQueryName] = useState<string>('')
  const [userList, setUserList] = useState<listOption[]>([])
  // Query when field value is empty (clean step)
  const [getUsers, { data: users }] = useSearchUsersLiteLazyQuery()

  useEffect(() => {
    getUsers({
      variables: {
        searchQuery: {
          ...(queryName && { name: queryName.trim() }),
        },
        pagination: { limit: 10, offset: 0 },
      },
    })
  }, [queryName])

  useEffect(() => {
    if (!isNil(users))
      setUserList(
        uniqBy(
          users.searchUsers.map((user) => ({
            value: user.id,
            label: `${user.firstName} ${user.lastName}`,
          })),
          'value'
        )
      )
  }, [users])

  return (
    <Grid container spacing={3}>
      <Grid size="grow">
        <AsyncAutoCompleteField
          getValue={(value) => setQueryName(value)}
          label={t('home.tabs.users')}
          name="userId"
          value={''}
          options={userList}
        />
      </Grid>
    </Grid>
  )
}

export default AsyncAutoCompleteUsers
